import Immutable from 'immutable';
import {
  CLEAR_SALES_SESSION_DEBIT_NOTES,
  FLAG_GETTING_SALES_SESSION_DEBIT_NOTES,
  GET_SALES_SESSION_DEBIT_NOTES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_SALES_SESSION_DEBIT_NOTES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_SALES_SESSION_DEBIT_NOTES:
      return state.setIn(['all', 'content'], Immutable.List(action.payload));
    case CLEAR_SALES_SESSION_DEBIT_NOTES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
